import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-translate';
import YoutubeModal from 'react-youtube-modal';
import { Button, Container, Grid, Header, Icon, Image, Label, List, Modal, Segment } from 'semantic-ui-react';
import envList from '../../../constants/envList';
import PDFService, { PageType } from '../../../services/PDFService';
import HeaderComponent from '../../shared/HeaderComponent';
import JobList from '../projet/jobList';
import productInfos from '../projet/productInfos';
import ComponentTable from './ComponentTable';
import ComponentTableCP from './componentTableCP';
import ComponentTableIME from './ComponentTableIME';
import './StandardSoluceComponent.css';

class StandardSoluceComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    if (props.location && props.location.state) {
      this.state = props.location.state;
    }

    // State a initialiser ici
    const { isoValue } = this.state;

    this.state.membraneRouleaux = Math.ceil((isoValue * 1.3) / 75);
    this.state.suspentes = isoValue * 2.5;
    this.state.suspentesQuantity = (isoValue * 2.5) / 50;
    this.state.membranePareVapeur = isoValue * 1.3;
    this.state.solidouble = isoValue * 2.35;
    this.state.solidoubleQuantity = Math.ceil(
      (isoValue * 2.35) / 40
    );
    this.state.masticRT = isoValue * 0.5;
    this.state.masticrtQuantity = Math.ceil((isoValue * 0.5) / 12);

    this.onClickModalBTN = this.onClickModalBTN.bind(this);
  }

  componentDidMount() {
    const { resValue } = this.state;
    const { match: { params: { env } } } = this.props;
    window.scrollTo(0, 0);

    if (envList.isCP(env) && [9, 11, 12].includes(Number(resValue))) {
      this.setState({ modalOpen: true });
    }
  }

  onClickModalBTN() {
    this.setState({ modalOpen: false }, () => {
      this.redirect();
    });
  }

  getJob = () => {
    const token = sessionStorage.getItem('USER_TOKEN');
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const tmp = JSON.parse(window.atob(base64));
      return tmp.job;
    }

    return JobList.USER;
  };

  redirect() {
    const { match: { params: { env } }, history } = this.props;

    history.push({
      pathname: `/${env}/${productInfos[env].formula.standard.next || 'rtmax'}`,
      state: this.state,
    });
  }


  screenPage() {
    // document.getElementById("StandardSoluce").css({ 'padding' })
    PDFService.screenPage(PageType.STANDARD).then(() => {
      this.redirect();
    });
  }

  advantagesrender() {
    const { match: { params: { env } }, t } = this.props;

    const jobId = this.getJob();

    const advantages = productInfos[env].formula.standard.advantageKey[jobId].map(advantageId => (
      <li className="listItemBenefit">
        {t(advantageId)}
      </li>
    ));

    return (
      <ul className="listBenefit">
        {advantages}
      </ul>
    );
  }

  inconvenienceRender() {
    const { match: { params: { env } }, t } = this.props;

    const jobId = this.getJob();

    const inconvenience = productInfos[env]
      .formula.standard
      .inconvenienceKey[jobId]
      .map(inconvenienceId => (
        <li className="listItemBenefit">
          {t(inconvenienceId)}
        </li>
      ));

    return (
      <ul className="listBenefit">
        {inconvenience}
      </ul>
    );
  }

  componentRender() {
    const { match: { params: { env } }, t } = this.props;
    const { showMonocouche } = this.state;

    const components = productInfos[env]
      .formula.standard.components.map(component => (
        <List.Item
          className="listStandard"
          style={
            !component.alwaysShow && showMonocouche
              ? { display: 'none' }
              : { display: 'block' }
          }
        >
          {t(component.key)}
        </List.Item>
      ));

    if (showMonocouche && env === envList.CA.path) {
      components.splice(3, 0, (
        <List.Item
          className="listStandard"
          style={
            { display: 'block' }
          }
        >
          {t('standard_solidouble')}
        </List.Item>
      ));
    }

    return components;
  }

  render() {
    const { t, match: { params: { env } }, history, location } = this.props;
    const {
      showMonocouche,
      resValue,
      isEnough,
      thermalValue,
      epaisseurChevron,
      isoValue,
      conformity,
      productOptions,
      suspentesStandardItem,
      modalOpen,
      standardTotal,
    } = this.state;
    const jobId = this.getJob();

    const { formula: { standard } } = productInfos[env];
    let componentTable;
    switch (env) {
      case envList.CP.path:
        componentTable = (
          <ComponentTableCP
            resValue={resValue}
            isoValue={isoValue}
            onStandardTotalChange={(total) => {
              this.setState({ standardTotal: total });
            }}
            onConformitychange={(newConformity) => {
              this.setState({ conformity: newConformity });
            }}
            onIsEnoughChange={(enough) => {
              this.setState({ isEnough: enough });
            }}
            onThermalChange={(thermalVal) => {
              this.setState({ thermalValue: thermalVal });
            }}
          />
        );
        break;
      case envList.IME.path:
        componentTable = (
          <ComponentTableIME
            resValue={resValue}
            isoValue={isoValue}
            onStandardTotalChange={(total) => {
              this.setState({ standardTotal: total });
            }}
            onConformitychange={(newConformity) => {
              this.setState({ conformity: newConformity });
            }}
            onIsEnoughChange={(enough) => {
              this.setState({ isEnough: enough });
            }}
            onThermalChange={(thermalVal) => {
              this.setState({ thermalValue: thermalVal });
            }}
          />
        );
        break;
      default:
        componentTable = (
          <ComponentTable
            t={t}
            location={location}
            showMonocouche={showMonocouche}
            jobId={jobId}
            resValue={resValue}
            epaisseurChevron={epaisseurChevron}
            isoValue={isoValue}
            productOptions={productOptions}
            suspentesStandardItem={suspentesStandardItem}
            onStandardTotalChange={(total) => {
              this.setState({ standardTotal: total });
            }}
            onConformitychange={(newConformity) => {
              this.setState({ conformity: newConformity });
            }}
            onIsEnoughChange={(enough) => {
              this.setState({ isEnough: enough });
            }}
            onThermalChange={(thermalVal) => {
              this.setState({ thermalValue: thermalVal });
            }}
          />
        );
    }
    return (
      <div>
        <HeaderComponent
          currentPage={3}
          commonState={this.state}
          history={history}
        />
        <Container id="StandardSoluce">
          <Segment>
            <Container as="h2" id="standardTitle">
              {t('standard_solution_title')}
            </Container>

            <Grid columns={1}>
              <Grid.Row>
                <Grid.Column width={100}>
                  { standard.displayTuto && (
                    <div>
                      <YoutubeModal videoId={standard.tutoVideoId} height="400px" width="700px">
                        <Button
                          floated="right"
                          id="tutorialButton"
                          size="big"
                          target="_blank"
                        >
                          {t('standard_tutorial_button')}
                          <Icon name="wrench" id="iconTuto" />
                        </Button>
                      </YoutubeModal>
                    </div>
                  )}
                  <Segment basic id="standardText">
                    {t(standard.descriptionKey[JobList.PRO])}
                    {' '}
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Segment basic>
              <Grid columns="equal" id="tabContainer">
                <Grid.Row>
                  <Grid.Column className="tabCell standardCell">
                    <div className="rowText">
                      <ul className="avantageTitle">
                        {t('standard_advantages_title')}
                      </ul>
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell standardCell">
                    <div className="rowText">
                      <ul className="avantageTitle">
                        {t('standard_disadvantages_title')}
                      </ul>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid columns="equal" id="tabContainer">
                <Grid.Row>
                  <Grid.Column className="tabCell standardCell">
                    <div className="rowText">
                      {this.advantagesrender()}
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell standardCell">
                    <div className="rowText">
                      {this.inconvenienceRender()}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment>
              <Grid>
                <Grid.Row>
                  <Grid.Column
                    computer={8}
                    tablet={16}
                    id="composantListImgContainer"
                    style={{
                      display: 'flex',
                    }}
                  >
                    <Image
                      src={
                        showMonocouche
                          ? standard.composantsImg
                          : standard.composantsBicImg
                      }
                      size="big"
                    />
                    {standard.asterisk ? '*' : ''}
                  </Grid.Column>
                  <Grid.Column
                    computer={8}
                    tablet={16}
                    id="col_comp"
                  >
                    <List divided relaxed fluid ordered>
                      <Label as="h2" id="composantTitle">
                        {t('standard_component_list')}
                      </Label>
                      {this.componentRender()}
                    </List>
                    {standard.asterisk ? t('asterisk') : ''}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment className="segmentPanneau">
              <Grid>
                <Grid.Row id="standardPanneau">
                  <Grid.Column tablet={8} computer={4}>
                    <Segment basic className="segmentPannel">
                      <div as="h4" className="StandardSoluceTitle">
                        {' '}
                        {t('standard_reswait')}
                      </div>
                      <div className="SoluceNumbers">
                        {resValue}
                        {t('standard_res_unit')}
                      </div>
                      <div className="underlinePanneau">
                        ____________________________
                      </div>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column tablet={8} computer={4}>
                    <Segment basic className="segmentPannel">
                      <div as="h4" className="StandardSoluceTitle">
                        {' '}
                        {t('standard_thermal_res')}
                      </div>
                      <div
                        className={
                          isEnough
                            ? 'SoluceNumbers'
                            : 'SoluceNumbers Invalid'
                        }
                      >
                        {thermalValue || 0}
                        {t('standard_thermal_res_unit')}
                      </div>
                      <div
                        className={
                          isEnough
                            ? 'underlinePanneau'
                            : 'underlinePanneau Invalid'
                        }
                      >
                        ____________________________
                      </div>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column tablet={12} computer={8}>
                    { productInfos[env].haveCpt
                      && (
                        <Segment basic className="segmentPannel">
                          <div as="h4" className="StandardSoluceTitle">
                            {' '}
                            {
                              t('standard_conformity')
                            }
                          </div>
                          <div
                            className={
                              conformity
                                ? 'SoluceNumbers'
                                : 'SoluceNumbers Invalid'
                            }
                          >
                            {
                              conformity
                                ? t('standard_conformity_res')
                                : t('standard_conformity_resp')
                            }
                            {conformity && <Icon />}
                          </div>
                          <div
                            className={
                              conformity
                                ? 'underlinePanneau'
                                : 'underlinePanneau Invalid'
                            }
                          >
                            ____________________________
                          </div>
                        </Segment>
                      )
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            {componentTable}

            <Segment basic id="totalStandardSoluce">
              <List floated="right" horizontal>
                <List.Item id="textTotal">{t('standard_total')}</List.Item>
                <List.Item id="totalNumbers">
                  {Math.ceil(standardTotal || 0).toLocaleString()}
                  {' '}
                  €
                </List.Item>
                <List.Item id="underscoreTotal">
                  ____________________________
                </List.Item>
              </List>
            </Segment>
            <Container
              style={{
                textAlign: 'right',
                marginTop: '65px',
                marginBottom: '25px',
                width: '101%',
              }}
            >
              <Button
                color="green"
                size="big"
                id="btnNext"
                onClick={() => this.screenPage()}
              >
                {t('standard_nextbutton')}
                <Icon name="long arrow alternate right" />
              </Button>
            </Container>
          </Segment>
        </Container>
        <Modal
          id="IncompatibleRModal"
          open={modalOpen}
          onClose={this.handleClose}
        >
          <Header
            icon="times"
            color="red"
            content={t('title_modal_impossible_configuration')}
          />
          <Modal.Content>
            <h3>{t('incompatible_r')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.onClickModalBTN} inverted>
              <Icon name="checkmark" />
              {' '}
              {t('incompatible_modal_next')}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

StandardSoluceComponent.propTypes = {
  location: PropTypes.any,
  match: PropTypes.any,
  history: PropTypes.any,
  t: PropTypes.func,
};

export default translate('StandardSoluceComponent')(StandardSoluceComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/standard/StandardSoluceComponent.jsx